import { type ReactNode, createContext } from 'react'

interface FrameBuilderLanguageContextProps {
  locale: string
}

export const FrameBuilderLanguageContext =
  createContext<FrameBuilderLanguageContextProps>({
    locale: '',
  })

interface FrameBuilderLanguageProviderProps {
  locale: string
  children: ReactNode
}

export const FrameBuilderLanguageProvider = ({
  locale,
  children,
}: FrameBuilderLanguageProviderProps) => {
  return (
    <FrameBuilderLanguageContext.Provider
      value={{
        locale,
      }}
    >
      {children}
    </FrameBuilderLanguageContext.Provider>
  )
}
